import { BaseService } from '@/api/services/BaseService';
import type { AgentRoomType, CreateRoomResponse } from '@/types/chat';

// Старт Camunda/Matrix-операций на бэке бывает дольше дефолтного таймаута — даём запас.
const WRITE_TIMEOUT_MS = 60_000;

// Control-plane чата (chat-service). Сообщения сюда НЕ ходят — их шлёт matrix-js-sdk напрямую в homeserver.
// Используем ТОЛЬКО агентские комнаты сделки (топология через агента); offer-комнаты и proposals не нужны.
class ChatService extends BaseService {
  /**
   * Get-or-create агентскую комнату сделки. Возвращает roomId (ЛОКАЛПАРТ — без :server).
   * Для USER (покупатель/продавец) roomType не передаём — бэкенд выводит из роли в сделке.
   * Для AGENT roomType обязателен (AGENT_AND_BUYER | AGENT_AND_SELLER) — у агента 2 комнаты на сделку.
   * Предусловия бэкенда: сделка IN_PROGRESS, есть agentUserId, вызывающий — участник (иначе 400/404).
   */
  async getOrCreateAgentRoom(
    bargainId: number,
    options?: { roomType?: AgentRoomType; createIfMissed?: boolean },
  ): Promise<string> {
    // chat-service отвечает СЫРЫМ { roomId } — БЕЗ платформенного конверта { success, data },
    // поэтому unwrap здесь не применяем (он бы бросил на отсутствующем success).
    const response = await this.request<CreateRoomResponse>(
      {
        method: 'put',
        url: '/chat/room/bargain/agent',
        data: {
          bargainId,
          roomType: options?.roomType,
          createIfMissed: options?.createIfMissed ?? true,
        },
      },
      { retry: false, timeoutMs: WRITE_TIMEOUT_MS },
    );
    return response.data.roomId;
  }
}

export const chatService = new ChatService();
